import { useState, useEffect } from "react";

function useScreenSize() {
  // Get initial screen dimensions
  const width = window.innerWidth;
  const height = window.innerHeight;

  // States to track different screen properties
  const [isMobile, setIsMobile] = useState(width <= 768);
  const [isPortrait, setIsPortrait] = useState(width < height);
  const [isMobilePortrait, setIsMobilePortrait] = useState(
    width <= 768 && width < height
  );
  const [isMobileLandscape, setIsMobileLandscape] = useState(
    width <= 1024 && width > height
  );
  const [isTabletPortrait, setIsTabletPortrait] = useState(
    width <= 1024 && width > 768 && width < height
  );
  const [portraitScreenRatio, setPortraitScreenRatio] = useState(
    height / width
  );
  const [isTablet, setIsTablet] = useState(false);
  const [currentWidth, setCurrentWidth] = useState(width);

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setCurrentWidth(width);
      const aspectRatio = width < height ? height / width : width / height;

      // Check if the device is a mobile based on width
      setIsMobile(width <= 768);

      // Check if the orientation is portrait
      setIsPortrait(width < height);

      // Check if the device is in mobile landscape mode
      setIsMobileLandscape(width <= 1024 && width > height);

      // Check if the device is in mobile portrait mode
      setIsMobilePortrait(width <= 768 && width < height);

      setIsTabletPortrait(width <= 1024  && width > 768 && width < height);

      // Update the portrait screen ratio
      setPortraitScreenRatio(height / width);

      // Check if the device is an iPad based on the aspect ratio within a range
      const isTabletAspectRatio = aspectRatio >= 1.3 && aspectRatio <= 1.5 ? true :false ;

      setIsTablet(isTabletAspectRatio);
    }

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Initial check in case the component mounts after the window has been resized
    handleResize();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    width: currentWidth,
    isMobile,
    isPortrait,
    isMobilePortrait,
    isMobileLandscape,
    isTabletPortrait,
    portraitScreenRatio,
    isTablet, // Return the new isTablet state
  };
}

export default useScreenSize;